/* Measures a sticky header's height so section headers can stick just below it.
   Returns a ref to attach to the header and the measured height in px. */

import { useRef, useState, useEffect } from "react";

export function useStickyHeaderHeight() {
	const headerRef = useRef<HTMLDivElement>(null);
	const [headerHeight, setHeaderHeight] = useState(0);

	useEffect(() => {
		const el = headerRef.current;
		if (!el) return;

		const measure = () => setHeaderHeight(el.getBoundingClientRect().height);
		measure();

		const observer = new ResizeObserver(() => measure());
		observer.observe(el);
		return () => observer.disconnect();
	}, []);

	return { headerRef, headerHeight };
}
